import { forwardRef } from "react";
import { Box, Stack, Typography } from "@mui/material";
import { Profile, Followers, RecentPosts } from "../list-view";
import Actions from "./Actions";
// redux
import { useSelector } from "../../../redux/store";
// utils
// config
import colors from "../../../config/colors";
import Metrics from "./Metrics";

const Card = forwardRef(({ item, type = "creator-details", ...props }, ref) => {
  const isCurrentCreator = useSelector(
    (state) =>
      state.creator.creatorDetails?.wishlink_username ===
      item?.wishlink_username,
  );

  return (
    <Box
      ref={ref}
      data-cy="creator-card"
      sx={{
        border: `1px solid ${isCurrentCreator ? colors.primary500 : colors.gray100}`,
        borderRadius: "4px",
        p: "12px",
        gap: "12px",
        flexDirection: "column",
        cursor: "pointer",
        display: "flex",
        backgroundColor: colors.white,
        maxWidth: "280px",
        aspectRatio: "229/304",
      }}
      {...props}
    >
      <Profile item={item} />
      <Followers item={item} viewType="card" />
      <RecentPosts item={item} type={type} viewType="card" />
      <Metrics item={item} />
      <Actions item={item} />
    </Box>
  );
});

Card.displayName = "Card";

export default Card;
